export class ProductRatingRequest {
    public productId: number;
    public rating: number;
}